import {NetConfigMode} from "@/module/device/NetConfigMode";
import {noImg} from "@/asset/img";

export class PcreateForm {
    name = ""
    description = ""
    icon = noImg
    natureKey = ""
    netConfigMode = NetConfigMode.SMART_CONFIG
    companyId?: number = undefined
    categoryId?: number = undefined
}

export class PeditForm {
    id = -1
    name = ''
    description = ""
    icon = noImg
    natureKey  = ""
    netConfigMode = NetConfigMode.SMART_CONFIG
    categoryId?: number = undefined
}

export class PmacImportForm {
    productId!: number
    macs!: Array<string>

    constructor(productId: number) {
        this.init(productId)
    }

    init(productId: number): void {
        this.productId = productId
        this.macs = []
    }
}
